export default __webpack_public_path__ + "images/5P.55f9902.png";